import { type IIcon } from '@/app/types/iconType'

export const Pen = (props: Omit<IIcon, 'iconName'>) => {
    const { height = '16', width = '16', color = '#007DEE' } = props
    return (
        <svg width={width} height={height} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M0.5 12.3751V15.5001H3.625L12.8417 6.28346L9.71667 3.15846L0.5 12.3751ZM15.2583 3.8668C15.5833 3.5418 15.5833 3.0168 15.2583 2.6918L13.3083 0.741797C12.9833 0.416797 12.4583 0.416797 12.1333 0.741797L10.6083 2.2668L13.7333 5.3918L15.2583 3.8668Z'
                fill={color}
            />
        </svg>
    )
}
